// extracted by mini-css-extract-plugin
module.exports = {"input":"integer_input_input__3IiSQ","toggleIcon":"integer_input_toggleIcon__2TfIj","label":"integer_input_label__2PJFH","container":"integer_input_container__2JfjQ"};